import { AppShell, Burger, Button, Center, Container, Group, MantineProvider, Menu, Modal, PasswordInput, Text, TextInput, Title } from "@mantine/core";
import '@mantine/core/styles.css';
import { useDisclosure, useViewportSize, useWindowScroll } from "@mantine/hooks";
import { IconChevronDown } from "@tabler/icons-react";
import { Link } from 'gatsby';
import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import '../../css/FloatingNavbar.css';
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from '../../hooks/ReduxHooks';
import useLanguageNavigator from "../../hooks/useLanguageNavigator";
import { loadAuthFromStorage, loginAdmin } from "../../redux/authSlice";
import { availableLanguages, navTranslations, theme } from "../api";
import LangBar from "../LangBar";
import MyFooter from './MyFooter';
/* 
https://platform.deepseek.com/api_keys
sk-28f9a5b497ab44a1b31196dd910e1ea1
*/
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const dispatch = useDispatch()
	const { login, userRole } = useAuth()
	const [scroll, scrollTo] = useWindowScroll();
	const [opened, { toggle }] = useDisclosure();
  	const [scrolled, setScrolled] = useState(false);
	
	useEffect(() => {
		const handleScroll = () => { setScrolled(window.scrollY > 0) }
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);
    
	const bgArray = ['/herobg.jpg', '/bg2.webp']
	
	const tc = 'ss.8'
    const ts = 'sm'
    const fw = 700 
	const { language }: { language: 'en' | 'ar' } = useLanguageNavigator(availableLanguages)
	const lang = language === "en" ? "" : `/${language}`
	const [isModalOpen, setIsModalOpen] = useState(false)
	const onClose = () => setIsModalOpen(false)
	const { width } = useViewportSize()
	const loginData = {
		title: { en: 'Customer Login', ar: 'تسجيل دخول العميل' },
		description: { en: 'Only authorized customers can log in to track their business.', ar: 'يمكن فقط للعملاء المصرح لهم تسجيل الدخول لمتابعة أعمالهم.' },
		emailLabel: { en: 'Email', ar: 'الإيميل' },
		emailPlaceholder: { en: 'Enter your email', ar: 'أدخل الإيميل' },
		passwordLabel: { en: 'Password', ar: 'كلمة المرور' },
		passwordPlaceholder: { en: 'Enter your password', ar: 'أدخل كلمة المرور' },
		loginButton: { en: 'Login', ar: 'تسجيل الدخول' },
		forgotPassword: { en: 'If you can\'t remember your password or have any other issues, please', ar: 'إذا لم تتمكن من تذكر كلمة المرور الخاصة بك أو لديك أي مشاكل أخرى، فيرجى' },
		contactUs: { en: 'contact us', ar: 'التواصل معنا' },
		cancel: { en: 'Cancel', ar: 'إلغاء' },
		loadingData: { en: 'Logging in...', ar: 'جارى التسجيل...' }
	};
	const [email, setEmail] = useState('');
  	const [password, setPassword] = useState('');
	// const userType = useSelector((state: any) => state.auth.userType);
	// const userType:string = useSelector(state => state.auth.userType);
	const { loading, error, success, userType } = useSelector(state => {
		// console.log(state);
  		return state.auth;
	});
	const handleLogin = async () => {
		const resultAction = await dispatch(loginAdmin({ email, password }));
		if (loginAdmin.fulfilled.match(resultAction)) {
			login('admin'); // Set the role to 'admin' after successful login
			onClose(); // Close the modal
		}
	};
	useEffect(() => {dispatch(loadAuthFromStorage()) }, [dispatch]);
    return (
		<>
        <MantineProvider theme={theme}>
			{/* <div className="body-bg" style={{backgroundImage: `url(${bgArray[bg]})`}}> */}
			<div className="body-bg" style={{backgroundImage: `url(${bgArray[0]})`}}>
			<AppShell
				header={{ height: 60, }}
				navbar={{ width:200 , breakpoint: 'sm', collapsed: { desktop: true, mobile: !opened }, }}
				padding="md"
			>
			<AppShell.Header style={{ backgroundColor:'rgba(255,255,255,0.95)' }} className={`floatingNavbar ${scroll.y > 80 ? 'scrolled' : ''}`}>
				{
					width > 766 ?
				<div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', height:'100%' }}>
                    <Group h="100%">
                        <Link to={`${lang}/`} className="logo" >
                            <StaticImage src='../../images/logot.png' alt="Logo" placeholder="blurred" height={50} style={{ marginTop:'1px', marginLeft:'10px', marginRight:'10px' }}/>
                        </Link>
                        <Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100}>
                            <Menu.Target>
                                <Text component={Link} c={'ss.9'} size="xl" fz={22} fw={500} to={`${lang}/`}>{navTranslations[language].home}</Text>
                            </Menu.Target>
                        </Menu>
						{
							userType === 'admin' ?
							<Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100}>
								<Menu.Target>
									<Text component={Link} c={'ss.5'} size="xl" fz={22} fw={500} to={`/admin`}>Admin</Text>
								</Menu.Target>
							</Menu> : <></>
						}
                        <Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100}>
                            <Menu.Target>
                                <div style={{ display:'flex', alignItems:'center', flexDirection:'row' }}>
                                    <Text component={Link} c={'ss.9'} p={0} m={0} fz={22} fw={500} to="#">{navTranslations[language].services}</Text>
                                    <div  style={{ height:'100%', paddingTop:'10px' }}>
                                        <IconChevronDown stroke={1.5}/>
                                    </div>
                                </div>
                            </Menu.Target>
                            <Menu.Dropdown className="logo-font" style={{ outline: '1px solid #020a6d', borderRadius:'10px', background:'argb(255,255,255,0.1)' }} >
                                <Menu.Item component={Link} to={`${lang}/webApps`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].webApps}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/websites`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].websites}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/mobileApps`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].mobileApps}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/iot`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].iot}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/electronics`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].electronics}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/mixedSolutions`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].mixedSolutions}</Text></Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                        <Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100} offset={4}>
                            <Menu.Target>
                                <div style={{ display:'flex', alignItems:'center', flexDirection:'row' }}>
                                    <Text component={Link} c={'ss.9'} p={0} m={0} fz={22} fw={500} to="#">{navTranslations[language].aboutUs}</Text>
                                    <div  style={{ height:'100%', paddingTop:'10px' }}>
                                        <IconChevronDown stroke={1.5}/>
                                    </div>
                                </div>
                            </Menu.Target>
                            <Menu.Dropdown className="logo-font" style={{ outline: '1px solid #020a6d', borderRadius:'10px', background:'argb(255,255,255,0.1)' }}>
                                <Menu.Item component={Link} to={`${lang}/ourStory`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].ourStory}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/contactUs`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].contactUs}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/careers`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].careers}</Text></Menu.Item>
                                <Menu.Item component={Link} to={`${lang}/sustainability`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].sustainability}</Text></Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                        {/* <Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100}>
                            <Menu.Target>
                                <Text component={Link} c={'ss.9'} p={0} m={0} fz={22} fw={500} to={`${lang}/contactUs`}>{navTranslations[language].contactUs}</Text>
                            </Menu.Target>
                        </Menu> */}
                    <LangBar />
                    </Group>
                    <Button onClick={() => setIsModalOpen(true)} variant="gradient" c={'#FFF'} size={"compact-lg"} className="control" m={0}
                    gradient={{ from: 'indigo', to: 'grape', deg: 130 }} mr={'10px'} ml={'10px'}>{navTranslations[language].login}</Button>
                </div>
				:
				<div style={{ display:'flex', justifyContent:'flex-start', alignItems:'center', height:'100%' }}>
					<Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="lg" color={'ss.9'} />
					<Group h="100%">
						<Link to="/" className="logo" >
							<StaticImage src='../../images/logot.png' alt="Logo" placeholder="blurred" height={50} style={{ marginTop:'1px', marginLeft:'5px' }}/>
						</Link>
						<Menu key={Math.random()} trigger="hover" openDelay={10} closeDelay={100}>
							<Menu.Target>
								<Text component={Link} c={'ss.9'} size="xl" fz={25} fw={600} to="/">Smart Softek</Text>
							</Menu.Target>
						</Menu>
					</Group>
				</div>
				}
			</AppShell.Header>

			<AppShell.Navbar px={4}>
				{
					opened ?
					<>
					<div style={{ marginTop:'22px' }}></div>
					<Menu shadow="md">
						<Menu.Label>{navTranslations[language].home}</Menu.Label>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].home}</Text></Menu.Item>
						<Menu.Label>{navTranslations[language].services}</Menu.Label>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/webApps`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].webApps}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/websites`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].websites}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/mobileApps`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].mobileApps}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/iot`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].iot}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/electronics`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].electronics}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/mixedSolutions`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].mixedSolutions}</Text></Menu.Item>
						<Menu.Label>{navTranslations[language].aboutUs}</Menu.Label>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/ourStory`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].ourStory}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/contactUs`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].contactUs}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/careers`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].careers}</Text></Menu.Item>
						<Menu.Item component={Link} onClick={toggle} to={`${lang}/sustainability`}><Text c={tc} size={ts} fw={fw}>{navTranslations[language].sustainability}</Text></Menu.Item>  
					</Menu>
					<Center mt={12}>
						<Button onClick={() => {toggle(); setIsModalOpen(true);}} variant="gradient" c={'#FFF'} size={"compact-lg"} radius="xl" className="control" m={0}
							gradient={{ from: 'indigo', to: 'grape', deg: 130 }} mr={'10px'} ml={'10px'} w={'120px'}>{navTranslations[language].loginData}</Button>
					</Center>
					</>
					:
					<></>
				}
			</AppShell.Navbar>

			<AppShell.Main>
				<div style={{ marginTop:"22px" }}></div>
				{children}
				<MyFooter />
			</AppShell.Main>
			</AppShell>
			</div>
			<Modal
                opened={isModalOpen} onClose={onClose} centered size="md" radius="lg"
                closeOnClickOutside={false} // Prevent closing by clicking outside
                closeOnEscape={false} // Prevent closing by pressing Escape
                withCloseButton={false} // Remove the default close button
                overlayProps={{ opacity: 0.8, }} // Semi-transparent overlay
            >
                <Container> 
                    <Center><Title c={"ss.9"} order={3} mb="sm">{loginData['title'][language]}</Title></Center>
                    <Text c={"ss.8"} mb="xl">{loginData['description'][language]}</Text>
                    <TextInput onChange={(e) => setEmail(e.currentTarget.value)} c={"ss.8"} label={loginData['emailLabel'][language]} placeholder={loginData['emailPlaceholder'][language]} required mb="md"/>
                    <PasswordInput onChange={(e) => setPassword(e.currentTarget.value)} c={"ss.8"} label={loginData['passwordLabel'][language]} placeholder={loginData['passwordPlaceholder'][language]} required mb="xl"/>
                    {error && (<Text c="red" mb="md">{error}</Text>)}
					{/* <Button fullWidth size="md" mb="md" color={"ss"} radius="md">{loginData['loginButton'][language]}</Button> */}
					<Button fullWidth size="md" mb="md" color={"ss"} radius="md" onClick={handleLogin} disabled={loading}>
						{loading ? loginData['loadingData'][language] : loginData['loginButton'][language]}
					</Button>
                    <Text c={"ss.8"} mb="sm">
                        {loginData['forgotPassword'][language]}{" "}
						<Text fw={700} c={"ss.8"} style={{ textDecoration: "underline" }} component={Link} to={`${lang}/contactUs`} onClick={onClose}>
							{loginData['contactUs'][language]}
						</Text>.
                    </Text>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button variant="outline" color="red" onClick={onClose}>{loginData['cancel'][language]}</Button>
                    </div>
                </Container>
            </Modal>
		</MantineProvider>
		</>
    )
}

export default Layout

			/* <div className="body-bg" key={bg} style={{backgroundImage: `url(${bgArray[bg]})`}}> */
// const location = typeof window !== 'undefined' ? useLocation() : null; // Avoid SSR issues
  	// const [isClient, setIsClient] = useState(false);

    // const [isClient, setIsClient] = useState(false)
    // useEffect(() => {setIsClient(true)}, []);
    // if (!isClient) return <div>Loading...</div>;

// const routeToBgMap: {[key: string]: number} = useMemo(() => ({
	// '^(/(en|ar|fr|es|ru|de|it|zh|tr|hi))?/?$': 0,			// Home
	// '^(/(en|ar|fr|es|ru|de|it|zh|tr|hi))?/contactUs/?$': 1,	// Contact Us
	// '^(/(en|ar|fr|es|ru|de|it|zh|tr|hi))?/about/?$': 2,		// About
	// }), []);
	// useEffect(() => {
	// 	if (typeof window !== 'undefined') {
	// 		const matchedRoute = location ? Object.keys(routeToBgMap).find((pattern) => new RegExp(pattern).test(location.pathname)) : undefined;
	// 		if(matchedRoute == undefined){ if (bg !== 0) setBg(0) } else {
	// 			const newBg = routeToBgMap[matchedRoute] ?? 0;
	// 			if (newBg !== bg){ setBg(newBg) } 
	// 		}
	// 	}
	// }, [location?.pathname, routeToBgMap]); // , bg
	

/* 
<Helmet>
	<title>Smart Softek</title>
	<meta name="description" content="Smart Softek provides innovative technology solutions, including web apps, IoT solutions, and embedded systems." />
	<meta name="keywords" content="technology, web apps, mobile apps, IoT solutions, Smart Softek, website, " />
	<meta name="robots" content="index, follow" />
	<link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" rel="stylesheet" />

	<link rel="canonical" href="https://www.smartsoftek.com/" />
	<meta name="author" content="SmartSoftek" />
	<meta property="og:site_name" content="Smart Softek" />
	<meta property="og:type" content="website" />
	<meta property="og:title" content="Smart Softek Technologies" />

	<meta property="og:description" content="Web Application, Website, Electronics development and design" />
	<meta property="og:url" content="https://www.smartsoftek.com/" />
	<meta property="og:image" content="https://www.smartsoftek.com/images/logo.png" />
	<meta property="og:image:alt" content="Smart Softek Logo" />
	<meta property="og:image:width" content="400" />
	<meta property="og:image:height" content="400" />
	<meta name="twitter:card" content="summary" />
	<meta name="twitter:site" content="@smartsoftek" />
	<meta name="twitter:creator" content="@smartsoftek" />
	<meta name="twitter:title" content="Smart Softek Technologies" />
	<meta name="twitter:description" content="Web Application, Website, Electronics development and design" />
	<meta name="twitter:image" content="https://www.smartsoftek.com/images/logo.png" />
	<meta name="twitter:image:alt" content="Smart Softek Logo" />

	<meta name="viewport" content="width=device-width, initial-scale=1.0" />
	<meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
	<meta httpEquiv="X-UA-Compatible" content="ie=edge" />
	<meta name="theme-color" content="#663399" />
	<meta name="msapplication-navbutton-color" content="#663399" />
	<meta name="apple-mobile-web-app-status-bar-style" content="#663399" />
	<meta name="msapplication-TileColor" content="#663399" />
	<meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
	<meta name="msapplication-config" content="/browserconfig.xml" />
	<meta name="application-name" content="Smart Softek" />
	<meta name="msapplication-tooltip" content="Smart Softek" />
	<meta name="msapplication-starturl" content="/" />
	<meta name="msapplication-square70x70logo" content="/ms-icon-70x70.png" />
	<meta name="msapplication-square150x150logo" content="/ms-icon-150x150.png" />
	<meta name="msapplication-wide310x150logo" content="/ms-icon-310x150.png" />
	<meta name="msapplication-square310x310logo" content="/ms-icon-310x310.png" />

	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" />
	<link rel="dns-prefetch" href="https://fonts.googleapis.com" />
	<link rel="dns-prefetch" href="https://fonts.gstatic.com" />
	<link rel="dns-prefetch" href="https://www.google-analytics.com" />

	<script type="application/ld+json">
	{JSON.stringify({
		"@context": "https://schema.org",
		"@type": "Organization",
		"name": "Smart Softek",
		"url": "https://www.smartsoftek.com",
		"logo": "https://www.smartsoftek.com/images/logo.png",
		"description": "Innovative technology solutions.",
	})}
	</script>
</Helmet>
*/

/* 
<div className="body-bg" style={{backgroundImage: `url(${bgArray[bg]})`}}>
				<div style={{ padding:'12px' }}></div>
				<NavBar />
				<div style={{ marginTop:'22px' }}></div>
				<main>{children}</main>
				<footer>This is the footer</footer>
			</div>
*/